import _Close from "@mui/icons-material/Close";
import FlowCardText from 'app/components/onboardingFlows/OnboardingFlowCardText';
import React from 'react';
import { autoPlay } from 'react-swipeable-views-utils';
import SwipeableViews from 'react-swipeable-views';
import { IconButton, MobileStepper } from '@mui/material';
import { COLORS } from '@fupa/fupa-uikit';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import FlowCardMedia from 'app/components/onboardingFlows/OnboardingFlowCardMedia';
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);
const animationDuration = 4500;
const OnboardingFlowCard = _ref => {
  let {
    flows,
    handleClose
  } = _ref;
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = flows.length;
  const handleStepChange = step => {
    setActiveStep(step);
  };
  return /*#__PURE__*/React.createElement(Card, {
    sx: {
      maxWidth: 400,
      width: '80%',
      margin: 'auto',
      position: 'relative'
    },
    "data-sentry-element": "Card",
    "data-sentry-component": "OnboardingFlowCard",
    "data-sentry-source-file": "OnboardingFlowCard.tsx"
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleClose,
    sx: {
      position: 'absolute',
      zIndex: 1,
      right: 0,
      color: "".concat(COLORS.white)
    },
    "data-sentry-element": "IconButton",
    "data-sentry-source-file": "OnboardingFlowCard.tsx"
  }, /*#__PURE__*/React.createElement(_Close, {
    color: 'inherit',
    "data-sentry-element": "Close",
    "data-sentry-source-file": "OnboardingFlowCard.tsx"
  })), /*#__PURE__*/React.createElement(AutoPlaySwipeableViews, {
    interval: animationDuration,
    axis: 'x',
    index: activeStep,
    onChangeIndex: handleStepChange,
    enableMouseEvents: true,
    "data-sentry-element": "AutoPlaySwipeableViews",
    "data-sentry-source-file": "OnboardingFlowCard.tsx"
  }, flows.map(flow => /*#__PURE__*/React.createElement(FlowCardMedia, {
    key: "flow-media-".concat(flow.id),
    animationData: flow.animationSrc
  }))), flows.length > 1 && /*#__PURE__*/React.createElement(MobileStepper, {
    sx: {
      justifyContent: 'center'
    },
    backButton: null,
    nextButton: null,
    steps: maxSteps,
    position: "static",
    activeStep: activeStep
  }), /*#__PURE__*/React.createElement(AutoPlaySwipeableViews, {
    interval: animationDuration,
    axis: 'x',
    index: activeStep,
    onChangeIndex: handleStepChange,
    enableMouseEvents: true,
    "data-sentry-element": "AutoPlaySwipeableViews",
    "data-sentry-source-file": "OnboardingFlowCard.tsx"
  }, flows.map(flow => /*#__PURE__*/React.createElement(FlowCardText, {
    key: "flow-text-".concat(flow.id),
    title: flow.title,
    description: flow.description
  }))), /*#__PURE__*/React.createElement(CardActions, {
    "data-sentry-element": "CardActions",
    "data-sentry-source-file": "OnboardingFlowCard.tsx"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleClose,
    sx: {
      marginLeft: 'auto'
    },
    color: "secondary",
    size: "small",
    "data-sentry-element": "Button",
    "data-sentry-source-file": "OnboardingFlowCard.tsx"
  }, "Verstanden")));
};
export default OnboardingFlowCard;